/**
 * cart-drawer.js — PATCHED v1.1
 * Fixes: NaN subtotal, "undefined items", NaN shipping message
 * Root cause: /cart/change.js response can omit item_count / total_price
 *             in some Shopify plan/region configs. Added safe fallbacks.
 */
(function () {
  'use strict';

  var drawer      = document.getElementById('kCartDrawer');
  var backdrop    = document.getElementById('kCartBackdrop');
  var closeBtn    = document.getElementById('kcdClose');
  var body        = document.getElementById('kcdBody');
  var itemsEl     = document.getElementById('kcdItems');
  var skeleton    = document.getElementById('kcdSkeleton');
  var footer      = document.getElementById('kcdFooter');
  var countEl     = document.getElementById('kcdItemCount');
  var subtotalEl  = document.getElementById('kcdSubtotal');
  var continueBtn = document.getElementById('kcdContinue');
  var noteToggle  = document.getElementById('kcdNoteToggle');
  var noteInput   = document.getElementById('kcdNote');
  var shipMsg     = document.getElementById('kcdShippingMsg');

  function allCountBadges() {
    return document.querySelectorAll('[data-cart-count]');
  }

  if (!drawer) return;

  /* ── FIX 1: fmt() — safe, never returns NaN ────────────
     Shopify prices are in paise (₹1 = 100 paise).
     If value is null/undefined/NaN → return '—' not '₹NaN'
  ─────────────────────────────────────────────────────── */
  function fmt(paise) {
    var n = parseFloat(paise);
    if (isNaN(n) || n === null || n === undefined) return '—';
    return '₹' + (n / 100).toLocaleString('en-IN');
  }

  /* ── FIX 2: safe cart field helpers ────────────────────
     /cart/change.js sometimes omits item_count / total_price.
     Fall back to computing them from cart.items array.
  ─────────────────────────────────────────────────────── */
  function safeItemCount(cart) {
    if (typeof cart.item_count === 'number') return cart.item_count;
    /* Fallback: sum quantities across all items */
    if (Array.isArray(cart.items)) {
      return cart.items.reduce(function (sum, i) {
        return sum + (parseInt(i.quantity, 10) || 0);
      }, 0);
    }
    return 0;
  }

  function safeTotalPrice(cart) {
    if (typeof cart.total_price === 'number') return cart.total_price;
    /* Fallback: sum final_line_price of all items */
    if (Array.isArray(cart.items)) {
      return cart.items.reduce(function (sum, i) {
        return sum + (parseInt(i.final_line_price, 10) || 0);
      }, 0);
    }
    return 0;
  }

  /* ── FIX 3: changeQty — safe qty parse ─────────────────
     parseInt('', 10) returns NaN which gets sent to the API
     and causes a malformed response. Always default to 1.
  ─────────────────────────────────────────────────────── */
  function changeQty(lineIndex, delta) {
    var btns = drawer.querySelectorAll('[data-qty-dec],[data-qty-inc],[data-remove]');
    btns.forEach(function (b) { b.disabled = true; });

    var qtyVal = drawer.querySelector(
      '.kcd-item[data-line="' + lineIndex + '"] .kcd-qty-val'
    );
    /* FIXED: guard parseInt result with || 1 */
    var currentQty = qtyVal ? (parseInt(qtyVal.textContent, 10) || 1) : 1;
    var newQty = Math.max(0, currentQty + delta);

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ line: lineIndex, quantity: newQty }),
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart/change error: ' + r.status);
      return r.json();
    })
    .then(function (cart) {
      renderCart(cart);
    })
    .catch(function (err) {
      console.warn('[KuteerrCart] changeQty failed, re-fetching cart…', err);
      /* If API response was malformed, do a clean re-fetch */
      refreshCart();
    });
  }

  function removeItem(lineIndex) {
    changeQty(lineIndex, -999);
  }

  /* ── OPEN / CLOSE ─────────────────────────────────────── */
  var isOpen = false;

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    refreshCart();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;
  }

  /* ── FETCH ────────────────────────────────────────────── */
  function refreshCart(callback) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (callback) callback(cart);
      })
      .catch(function (err) {
        console.warn('[KuteerrCart] refreshCart failed', err);
        if (itemsEl) itemsEl.innerHTML =
          '<p style="color:rgba(255,231,196,.3);padding:2rem 0;' +
          'text-align:center;font-size:.85rem">Unable to load bag.</p>';
      });
  }

  /* ── RENDER ───────────────────────────────────────────── */
  function renderCart(cart) {
    if (skeleton) skeleton.style.display = 'none';

    /* ── FIX: always use safe computed values ── */
    var itemCount  = safeItemCount(cart);
    var totalPrice = safeTotalPrice(cart);

    /* Update ALL count badges */
    allCountBadges().forEach(function (el) {
      el.textContent = itemCount;
      el.classList.toggle('hidden', itemCount === 0);
      if (itemCount > 0) el.style.display = 'flex';
    });

    /* Header count — now guaranteed not "undefined items" */
    if (countEl) {
      countEl.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
    }

    /* Empty state */
    if (itemCount === 0) {
      if (itemsEl) itemsEl.innerHTML = emptyHTML();
      if (footer)  footer.style.display = 'none';
      return;
    }

    /* Subtotal — now guaranteed not ₹NaN */
    if (subtotalEl) subtotalEl.textContent = fmt(totalPrice);

    /* Shipping nudge — now guaranteed not ₹NaN */
    if (shipMsg) {
      var FREE_THRESHOLD = 5000000; /* ₹50,000 = 5,000,000 paise */
      if (totalPrice >= FREE_THRESHOLD) {
        shipMsg.innerHTML =
          '✦ You qualify for <strong style="color:#d4a843">free insured shipping</strong>';
      } else {
        var gap = FREE_THRESHOLD - totalPrice;
        shipMsg.textContent = 'Add ' + fmt(gap) + ' more for free insured shipping';
      }
    }

    /* Items */
    var frag = document.createDocumentFragment();
    (cart.items || []).forEach(function (item, idx) {
      var el = document.createElement('div');
      el.className = 'kcd-item';
      el.dataset.line = idx + 1;

      /* Safe price values */
      var linePrice    = parseInt(item.final_line_price, 10) || 0;
      var comparePrice = parseInt(item.compare_at_price, 10) || 0;
      var qty          = parseInt(item.quantity, 10) || 1;

      var compareHtml = '';
      if (comparePrice && comparePrice > linePrice) {
        compareHtml =
          '<span class="kcd-item-compare">' + fmt(comparePrice * qty) + '</span>';
      }

      var variantHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHtml = '<p class="kcd-item-variant">' + item.variant_title + '</p>';
      }

      el.innerHTML =
        '<div class="kcd-item-img">' +
          '<img src="' + (item.image
            ? item.image.replace(/(\.\w+)(\?|$)/, '_160x$1$2')
            : '') + '"' +
               ' alt="' + (item.product_title || '') + '" loading="lazy">' +
        '</div>' +
        '<div class="kcd-item-body">' +
          '<p class="kcd-item-craft">' + (item.product_type || '') + '</p>' +
          '<p class="kcd-item-name">' + (item.product_title || '') + '</p>' +
          variantHtml +
          '<div class="kcd-item-bottom">' +
            '<div style="display:flex;align-items:baseline;gap:.3rem">' +
              '<span class="kcd-item-price">' + fmt(linePrice) + '</span>' +
              compareHtml +
            '</div>' +
            '<div style="display:flex;align-items:center;gap:.75rem">' +
              '<div class="kcd-qty">' +
                '<button class="kcd-qty-btn" data-qty-dec data-line="' + (idx+1) + '"' +
                        (qty <= 1 ? ' disabled' : '') + '>−</button>' +
                '<span class="kcd-qty-val">' + qty + '</span>' +
                '<button class="kcd-qty-btn" data-qty-inc data-line="' + (idx+1) + '">+</button>' +
              '</div>' +
              '<button class="kcd-remove" data-remove data-line="' + (idx+1) + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      frag.appendChild(el);
    });

    if (itemsEl) {
      itemsEl.innerHTML = '';
      itemsEl.appendChild(frag);
    }

    if (footer) footer.style.display = 'block';
  }

  function emptyHTML() {
    return '<div class="kcd-empty">' +
      '<svg width="52" height="52" fill="none" stroke="rgba(255,231,196,.5)" stroke-width="1">' +
        '<rect x="8" y="16" width="36" height="32" rx="2"/>' +
        '<path d="M20 16c0-6.627 5.373-12 12-12"/>' +
        '<path d="M32 16c0-6.627-5.373-12-12-12"/>' +
        '<line x1="8" y1="26" x2="44" y2="26"/>' +
      '</svg>' +
      '<p class="kcd-empty-title">Your bag is empty</p>' +
      '<p class="kcd-empty-sub">Add a masterpiece to begin</p>' +
      '<a href="/collections" style="margin-top:.75rem;font-family:\'Jost\',sans-serif;' +
         'font-size:.68rem;letter-spacing:.18em;text-transform:uppercase;' +
         'color:rgba(184,134,11,.6);text-decoration:none">Explore Collection →</a>' +
    '</div>';
  }

  /* ── QTY / REMOVE delegation ──────────────────────────── */
  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var dec    = e.target.closest('[data-qty-dec]');
      var inc    = e.target.closest('[data-qty-inc]');
      var remove = e.target.closest('[data-remove]');
      if (dec && !dec.disabled) changeQty(parseInt(dec.dataset.line, 10), -1);
      if (inc && !inc.disabled) changeQty(parseInt(inc.dataset.line, 10), +1);
      if (remove) removeItem(parseInt(remove.dataset.line, 10));
    });
  }

  /* ── CLOSE ────────────────────────────────────────────── */
  if (closeBtn)    closeBtn.addEventListener('click', closeDrawer);
  if (backdrop)    backdrop.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  /* ── CART ICON ────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-cart-open]');
    if (cartBtn) { e.preventDefault(); openDrawer(); }
  });

  /* ── GIFT NOTE ────────────────────────────────────────── */
  if (noteToggle && noteInput) {
    noteToggle.addEventListener('click', function () {
      var visible = noteInput.classList.toggle('visible');
      noteToggle.textContent = visible ? '− Remove gift note' : '+ Add a gift note';
      if (visible) noteInput.focus();
    });
    var noteTimer;
    noteInput.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ note: noteInput.value }),
        });
      }, 600);
    });
  }

  /* ── EVENT: kuteerr:cart:updated ─────────────────────── */
  document.addEventListener('kuteerr:cart:updated', function (e) {
    if (e.detail && e.detail.openDrawer) { openDrawer(); }
    else if (isOpen) { refreshCart(); }
    else {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = safeItemCount(cart);
          allCountBadges().forEach(function (el) {
            el.textContent = n;
            el.classList.toggle('hidden', n === 0);
          });
        });
    }
  });

  /* ── INTERCEPT native ATC forms ──────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var origText  = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Accept': 'application/json' },
      body:    new FormData(form),
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Added ✓'; }
      setTimeout(function () {
        if (submitBtn) submitBtn.textContent = origText;
      }, 2000);
      openDrawer();
    })
    .catch(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
    });
  });

  /* ── INIT: page load badge count ─────────────────────── */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var n = safeItemCount(cart);
      allCountBadges().forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('hidden', n === 0);
        if (n > 0) el.style.display = 'flex';
      });
    });

  window.KuteerrCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };

}());